<template>
  <div class="home-wrapper">
    <AccountSettings />
    <v-icon @click="sign_out" class="logout"></v-icon>

    <v-container fluid class="home-container">
      <v-layout row align-start pb-1>
        <v-flex xs5>
          <ProfilePic
            :image="user_data.big_thumbnail"
            @upload="saveData"
            :accountActive="!user_data.accountNotActivated"
          />
        </v-flex>
        <v-flex @click="bottomSheet = 'view_profile'" xs7 pl-2 class="text-xs-left">
          <h3 class="name-with-settings">
            <span :title="user_data.name">{{ user_data.name }}</span>
            <v-icon ml-1>mdi-pencil</v-icon>
          </h3>
          <h4 class="header-thin">{{ user_data.position_specific }}</h4>
          <h4 class="header-thin">
            {{
              user_data.no_team === true || user_data.no_team === 'nein'
                ? user_data.currentTeam
                : 'Vereinslos'
            }}
          </h4>
          <h5>
            <flag class="flag" :iso="user_data.nationality" />
            {{ getNationality }}
          </h5>
        </v-flex>
      </v-layout>

      <v-layout mt-4 mb-1 align-start>
        <v-flex xs12 py-2 px-3 class="matches-box">
          <v-layout mb-2>
            <v-flex xs3>
              <h3>Matches</h3>
            </v-flex>
            <v-flex xs9 class="text-xs-right" style="font-size: 12px">
              <div class="mt-1">
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'all' }"
                  @click="selectedMatchType = 'all'"
                  >Alle</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'teams' }"
                  @click="selectedMatchType = 'teams'"
                  >Vereine</span
                >
                <span
                  class="d-inline-block"
                  :class="{ 'filter-span-active': selectedMatchType === 'scout' }"
                  @click="selectedMatchType = 'scout'"
                  >Scouts</span
                >
              </div>
            </v-flex>
          </v-layout>
          <div
            v-if="filteredPlayerMatches && filteredPlayerMatches.length"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <!-- @click="redirectToChat(profile.chat_id, profile.logo, profile.team ? profile.team : profile.name)" -->
            <MatchPreview
              @click="openMatchedProfile(profile)"
              class="player-preview"
              v-for="profile in filteredPlayerMatches"
              :key="profile.chat_id"
              :picture="profile.logo"
              :msg="profile.lastMessage"
              :chat-id="profile.chat_id"
              :name="profile.team ? profile.team : profile.name"
              :details="profile.contactByDetails"
              :showRemoveButton="true"
              :selectedMatch="profile"
            ></MatchPreview>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large color="white">mdi-volleyball</v-icon>
            <h4 style="color: white">Aktuell keine Matches vorhanden.</h4>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout mt-4 align-start>
        <v-flex xs12 py-2 px-3 class="connect-box">
          <h3>Connect-Anfragen</h3>
          <small>Bestätigung durch Verein steht noch aus.</small>
          <div
            v-if="appliedTeamsWithNoMatch.length && !loadingConnectQuestions"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <ConnectPreview
              class="player-preview"
              v-for="appliedTeam in appliedTeamsWithNoMatch"
              :key="appliedTeam.id"
              :showRemoveButton="true"
              :selectedProfile="appliedTeam"
              :picture="
                appliedTeam.big_thumbnail
                  ? appliedTeam.big_thumbnail
                  : appliedTeam.profile_pic
              "
              :name="appliedTeam.team_name"
              :detail1="appliedTeam.category.league"
              :detail2="appliedTeam.verband"
              :nationality="appliedTeam.nationality"
              @click="openProfile(appliedTeam, 'showTeam')"
              @updateAppliedTeams="updateAppliedTeams($event)"
            ></ConnectPreview>
          </div>
          <div class="full-spinner" v-else-if="loadingConnectQuestions">
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large>mdi-chat-processing-outline</v-icon>
            <h4 style="color: grey">Aktuell keine offenen Connect-Anfragen.</h4>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- <div class="button-box">
      <div class="button-wrapper mt-3">
        <v-btn color="white" @click="bottomSheet = 'filter'" class="menu-button main main-big mb-3">
          <v-icon>filter</v-icon>
        </v-btn>
        <label class="label-big">Matchingeinstellungen</label>
      </div>
    </div> -->

    <!-- profile edit -->
    <v-card
      :class="['bottom-sheet', { active: bottomSheet !== 'hidden' ? true : false }]"
    >
      <v-icon @click="closeMenu" color="white" class="closeBtn"
        >keyboard_backspace</v-icon
      >

      <div v-if="bottomSheet === 'profile_settings'" class="settings">
        <v-tabs
          fixed-tabs
          background-color="white"
          class="tabs"
          slider-color="light-green accent-4"
        >
          <v-tab href="#Spielerdaten">Spielerdaten</v-tab>
          <v-tab href="#Karriere">Karriere</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <v-tabs-items v-model="tab_mehr" :touchless="true">
            <v-tab-item :value="'Spielerdaten'">
              <v-card class="overview-profile" flat>
                <label>Vor- u. Nachname</label>
                <v-text-field
                  color="green"
                  v-model="user_data.name"
                  solo
                ></v-text-field>
                <label>Geburtsdatum</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  color="green"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="green"
                      v-model="formatDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="green"
                    ref="picker"
                    v-model="user_data.age"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                  ></v-date-picker>
                </v-menu>
                <label>Geschlecht</label>
                <v-select
                  color="green"
                  :items="sex"
                  v-model="user_data.sex"
                  solo
                ></v-select>
                <label>Größe (in cm)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.height"
                  solo
                ></v-text-field>
                <label>Gewicht (in kg)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.weight"
                  solo
                ></v-text-field>
                <label>Nationalität</label>
                <v-autocomplete
                  :no-data-text="'Keine Einträge vorhanden'"
                  :items="$store.state.nationalities"
                  item-text="item_text"
                  item-value="id"
                  color="green"
                  name="nationalities"
                  v-model="user_data.nationality"
                  solo
                ></v-autocomplete>

                <label>Wohnsitz (Land)</label>
                <v-autocomplete
                  :items="$store.state.countries"
                  color="green"
                  v-model="user_data.living_in_country"
                  solo
                ></v-autocomplete>

                <label>Sprachen</label>
                <v-select
                  v-model="user_data.languages"
                  color="green"
                  :items="$store.state.languages"
                  chips
                  multiple
                ></v-select>

                <label>Position</label>
                <v-select
                  color="green"
                  :items="$store.state.positions"
                  v-model="user_data.position"
                  solo
                  @change="setSpecificPosition(user_data.position)"
                ></v-select>

                <label v-if="user_data.position && user_data.position !== 'Torhüter'"
                  >Position ({{
                    user_data.position ? user_data.position : 'spezifisch'
                  }})</label
                >
                <v-select
                  v-if="user_data.position && user_data.position !== 'Torhüter'"
                  color="green"
                  :items="playerSpecificPosition"
                  v-model="user_data.position_specific"
                  solo
                ></v-select>

                <label>Nebenposition</label>
                <v-select
                  color="green"
                  :items="$store.state.secondPositions"
                  v-model="user_data.secondPosition"
                  @change="setSpecificSecondPosition(user_data.secondPosition)"
                  solo
                ></v-select>
                <div
                  v-if="
                    user_data.secondPosition &&
                    !$store.state.positionsWithoutSpecific.includes(
                      user_data.secondPosition,
                    )
                  "
                >
                  <label
                    >Nebenposition ({{
                      user_data.secondPosition
                        ? user_data.secondPosition
                        : 'spezifisch'
                    }})</label
                  >
                  <v-select
                    color="green"
                    :items="playerSpecificSecondPosition"
                    v-model="user_data.second_position_specific"
                    solo
                  ></v-select>
                </div>
                <label>Spielertyp</label>
                <v-select
                  color="green"
                  multiple
                  :items="$store.state.player_types"
                  v-on:input="limiter"
                  v-model="user_data.player_type"
                  solo
                ></v-select>

                <label>Bevorzugter Fuß</label>
                <v-select
                  color="green"
                  :items="this.$store.state.foot"
                  v-model="user_data.foot"
                  solo
                ></v-select>

                <h2 class="text-xs-left">Spielerstatus</h2>
                <v-switch
                  color="green"
                  v-model="user_data.no_team"
                  :label="user_data.no_team ? 'Aktiv' : 'Vereinslos'"
                ></v-switch>
                <label>
                  <span v-if="user_data.no_team">Aktueller</span>
                  <span v-else>Letzter</span>
                  Verein
                </label>
                <v-text-field
                  color="green"
                  v-model="user_data.currentTeam"
                  solo
                ></v-text-field>
                <label>Region/Verband</label>
                <v-select
                  color="green"
                  :items="$store.state.verband"
                  v-model="user_data.verband"
                  solo
                ></v-select>
                <label>Liga</label>
                <v-select
                  v-if="$store.state.user_data.verband"
                  color="green"
                  :items="$store.state.filter_leagues[user_data.verband]"
                  item-text="league"
                  item-value="category"
                  return-object
                  v-model="user_data.category"
                  solo
                ></v-select>

                <h2 class="text-xs-left">Links</h2>
                <label for>Link Transfermarkt-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.transfermarkt"
                  hint="Kopiere den Link von deinem Transfermarkt-Profil."
                  solo
                ></v-text-field>

                <label>Link FuPa-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.fupa"
                  hint="Kopiere den Link von deinem FuPa-Profil."
                  solo
                ></v-text-field>

                <label>Link Facebook-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.facebook"
                  hint="Kopiere den Link von deinem Facebook-Profil."
                  solo
                ></v-text-field>

                <label>Link Instagram-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.instagram"
                  hint="Kopiere den Link von deinem Instagram-Profil."
                  solo
                ></v-text-field>

                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h2>Mehr Infos</h2>
                    </template>

                    <div class="oveerview-profile">
                      <label>Bio</label>
                      <v-textarea
                        placeholder="Was zeichnet dich als Spieler aus?"
                        color="green"
                        v-model="user_data.bio"
                        solo
                      ></v-textarea>
                      <label>Geburtsort</label>
                      <v-text-field
                        color="green"
                        v-model="user_data.birthplace"
                        solo
                      ></v-text-field>

                      <label>Bundesland</label>
                      <v-text-field
                        color="green"
                        v-model="user_data.living_in_state"
                        solo
                      ></v-text-field>
                      <label>Größte Erfolge</label>
                      <v-textarea
                        placeholder="Aufstiege, Meistertitel, Pokalsiege..."
                        color="green"
                        v-model="user_data.successes"
                        solo
                      ></v-textarea>
                      <label>Auszeichnungen</label>
                      <v-textarea
                        placeholder="Torschützenkönig, Spieler des Jahres..."
                        color="green"
                        :items="sex"
                        v-model="user_data.prices"
                        solo
                      ></v-textarea>
                    </div>
                  </v-list-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <GalleryTab @save-data="saveData" />
            </v-tab-item>
            <v-tab-item :value="'Karriere'">
              <v-card class="overview-profile" flat>
                <v-list>
                  <v-list-group
                    v-for="(item, i) in user_data.history"
                    :key="i"
                    v-model="item.active"
                    no-action
                  >
                    <template v-slot:activator>
                      <div class="history-wrapper list-name">
                        <h2
                          v-text="
                            `Saison ${item.season ? item.season : 'bitte angeben'}`
                          "
                        ></h2>
                      </div>
                    </template>

                    <div class="history-content">
                      <v-icon
                        @click="deleteEntry(i)"
                        class="delete"
                        color="red"
                      ></v-icon>
                      <div class="history-column">
                        <label>Saison</label>
                        <v-select
                          :items="$store.state.seasons"
                          color="green"
                          placeholder="2018/2019"
                          v-model="item.season"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Verein</label>
                        <v-text-field color="green" v-model="item.team"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Altersklasse</label>
                        <v-select
                          :items="$store.state.age_classes"
                          color="green"
                          v-model="item.class"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Position</label>
                        <v-select
                          color="green"
                          :items="$store.state.positions_extended"
                          v-model="item.position"
                        ></v-select>
                      </div>
                      <label>Region/Verband</label>
                      <v-select
                        color="green"
                        :items="$store.state.verband"
                        v-model="item.verband"
                      ></v-select>
                      <div v-if="item.verband" class="history-column">
                        <label>Liga</label>
                        <v-select
                          v-if="item.verband"
                          color="green"
                          :items="$store.state.filter_leagues[item.verband]"
                          item-text="league"
                          item-value="league"
                          v-model="item.league"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Spiele</label>
                        <v-text-field
                          color="green"
                          v-model="item.games_player"
                        ></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Tore</label>
                        <v-text-field color="green" v-model="item.goals"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Assist</label>
                        <v-text-field
                          color="green"
                          v-model="item.assists"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
                <v-btn
                  @click="user_data.history.push({ season: null })"
                  class="primary-btn"
                  >Neuer Eintrag</v-btn
                >
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>

      <div v-if="bottomSheet === 'search_settings'" class="settings">
        <label>Landkreis</label>
        <v-select color="green" :items="landkreis" solo></v-select>
        <label>Bundesland</label>
        <v-select
          color="green"
          :items="$store.state.bundesland"
          v-model="$store.state.user_data.bundesland"
          solo
        ></v-select>
        <label>Liga</label>
        <v-select color="green" :items="liga" solo></v-select>
      </div>
    </v-card>

    <!-- profile -->
    <v-card
      :class="[
        'bottom-sheet',
        {
          active:
            bottomSheet !== 'hidden' && bottomSheet == 'view_profile' ? true : false,
        },
      ]"
    >
      <div class="bottom-sheet-head">
        <h3>
          <flag class="flag" :iso="user_data.nationality" />
          {{ user_data.name }}
        </h3>
      </div>
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div class="profile">
        <UserData :user-data="user_data" />
        <v-tabs fixed-tabs background-color="white" slider-color="light-green accent-4">
          <v-tab href="#Übersicht">Spielerdaten</v-tab>
          <v-tab href="#Karriere">Karriere</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <!-- <v-tab href="#Galerie">Galerie</v-tab> -->
          <v-tabs-items v-model="tab">
            <v-tab-item :value="'Übersicht'">
              <UserBio :user-data="user_data" />
            </v-tab-item>
            <v-tab-item :value="'Karriere'">
              <v-card class="overview-career" flat>
                <v-timeline v-if="sortedHistory.length > 0">
                  <v-timeline-item
                    v-for="(history, i) in sortedHistory"
                    :key="i"
                    color="light-green accent-4"
                    :right="i % 2 === 0"
                    :left="i % 2 === 1"
                    small
                  >
                    <HistoryCard :history="history" :side="i"></HistoryCard>
                  </v-timeline-item>
                </v-timeline>
                <div v-else class="history-content">
                  <h3>Bisher keine Karriere angegeben.</h3>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <v-card class="overview-career" flat>
                <div class="overview-profile" flat>
                  <div class="history-content">
                    <GalleryContent
                      v-if="hasPictures"
                      :images="bindedUserData.galleryImages"
                    />
                    <div v-else class="history-content">
                      <h3>Bisher keine Galerie angelegt.</h3>
                    </div>

                    <LinkCard
                      v-if="hasLinks"
                      :links="bindedUserData.videolinks"
                      :title="'Videos'"
                    />
                    <LinkCard
                      v-if="hasArticles"
                      :links="bindedUserData.newslinks"
                      :title="'Zeitungsartikel'"
                    />
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
      <div class="button-box-sticky" style="flex-direction: column">
        <button
          color="white"
          @click="bottomSheet = 'profile_settings'"
          class="menu-button main main-small mb-1"
        >
          <!-- <v-icon>edit</v-icon> -->
          PROFIL BEARBEITEN
        </button>
        <!-- <label class="label-big">Profil bearbeiten</label> -->
      </div>
    </v-card>

    <v-dialog v-model="accountNeedVerification" max-width="290">
      <v-card class="text-left">
        <v-card-title class="headline">Verifizierung Spieleraccount</v-card-title>

        <v-card-text
          >Damit auch du den begehrten <b>blauen C4T-Ring</b> für dein Profilbild
          erhältst, und somit in den Suchergebnissen von Vereinen oder Scouts vorrangig
          gelistet wirst, musst du deinen Account nur noch verifizieren.</v-card-text
        >

        <v-card-actions style="justify-content: center">
          <v-btn color="blue white--text" text @click="verifyAccount"
            >Jetzt verifizieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- match einstelungen -->
    <!-- <PlayerSearchTeam
      :show="bottomSheet === 'filter'"
      :showSaveButton="false"
      @save-and-close="closeMenu"
    /> -->

    <MatchSheetTeam
      v-if="showTeam && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showTeam = false"
      :show="showTeam"
      :showMatchButtons="false"
    ></MatchSheetTeam>

    <ScoutSheet
      v-if="showScout && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showScout = false"
      :show="showScout"
    ></ScoutSheet>
  </div>
</template>

<script>
import { db } from '@/db';
import HistoryCard from '@/components/HistoryCard';
import LinkCard from '@/components/settings/LinkCard';
// import SetImages from '@/components/settings/SetImages';
import ProfilePic from '@/components/home/ProfilePic';
import GalleryContent from '@/components/settings/GalleryContent';
import AccountSettings from '@/components/settings/AccountSettings';
import UserData from '../../components/profile/UserData';
import UserBio from '../../components/profile/UserBio';
import MatchPreview from '../../components/home/MatchPreview';
import ConnectPreview from '../../components/home/ConnectPreview';
import match from '../../mixins/match';
import MatchSheetTeam from '../../components/match/TeamSheet';
import ScoutSheet from '../../components/match/ScoutSheet';
// import PlayerSearchTeam from '../../components/home/PlayerSearchTeam';
import GalleryTab from '../../components/settings/edit/GalleryTab';
import common from '../../mixins/common';
import home from '../../mixins/home';

export default {
  name: 'home-player',

  components: {
    HistoryCard,
    LinkCard,
    // SetImages,
    ProfilePic,
    GalleryContent,
    AccountSettings,
    UserData,
    UserBio,
    MatchPreview,
    ConnectPreview,
    MatchSheetTeam,
    ScoutSheet,
    // PlayerSearchTeam,
    GalleryTab,
  },

  mixins: [match, common, home],

  data: () => ({
    dialog: false,
    editMode: false,
    menu: false,
    tab: null,
    tab_mehr: null,
    bottomSheet: 'hidden',
    profile_settings: false,
    search_settings: false,
    view_profile: false,
    history: [],
    select: { state: 'Florida', abbr: 'FL' },
    foot: ['Rechts', 'Links'],
    sex: ['Männlich', 'Weiblich'],
    selectedProfile: {},
    showTeam: false,
    showScout: false,
  }),

  computed: {
    playerSpecificPosition() {
      if (this.user_data.position === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.user_data.position === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.user_data.position === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      if (this.user_data.position === 'Torhüter') {
        return [];
      }
      return [];
    },
    playerSpecificSecondPosition() {
      if (this.user_data.secondPosition === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.user_data.secondPosition === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.user_data.secondPosition === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      if (this.user_data.secondPosition === 'Torhüter') {
        return [];
      }
      return [];
    },
  },

  methods: {
    openProfile(data, type) {
      this.selectedProfile = data;
      this[type] = true;
    },

    async openMatchedProfile(matchChat) {
      console.log(matchChat);
      if (matchChat.contactByDetails) {
        this.selectedProfile = {};
        this.$store.state.loading = true;
        const collection =
          matchChat.contactByDetails.type === 'scout' ? 'scouts' : 'teams';
        const type = collection === 'teams' ? 'showTeam' : 'showScout';
        const contactedBy = await db
          .collection(collection)
          .doc(matchChat.team_id)
          .get()
          .then((snapshot) => snapshot.data());

        this.selectedProfile = contactedBy;
        this[type] = true;

        this.$store.state.loading = false;
      }
    },

    updateAppliedTeams(deletedTeam) {
      this.appliedTeamsWithNoMatch = this.appliedTeamsWithNoMatch.filter(
        (team) => team.id !== deletedTeam.id,
      );
    },

    setSpecificPosition(position) {
      this.$set(this.user_data, 'position_specific', null);
      if (position === 'Torhüter') {
        this.user_data.position_specific = 'Torhüter';
      }
    },
    setSpecificSecondPosition(position) {
      this.$set(this.user_data, 'second_position_specific', null);
      if (position === 'Torhüter') {
        this.$set(this.user_data, 'second_position_specific', 'Torhüter');
      }
    },
    limiter(e) {
      if (e.length > 3) {
        this.user_data.player_type.pop();
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Maximal 3 Spielertypen',
        });
      }
    },
    deleteEntry(i) {
      const oldHistory = this.$store.state.user_data.history;
      const remove = oldHistory[i];
      const filteredItems = oldHistory.filter((item) => item !== remove);
      this.$store.state.user_data.history = filteredItems;
    },
    sign_out() {
      this.$store.state.logout_dialog = true;
    },
    saveImage() {
      db.collection('users')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
    saveData() {
      this.clearLinks();

      db.collection('users')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
  },

  beforeMount() {
    this.initialData = JSON.stringify(this.$store.state.user_data);
    this.getAppliedTeamWithNoMatches(this.userAppliedTeamsWithoutMatch);
  },

  created() {
    document.body.classList.add('main-background');
    this.accountNeedVerification = this.user_data.accountNotActivated;
  },
};
</script>
